<!--
 * @Author: Merlin
 * @Date: 2024-04-01 10:16:04
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-23 19:19:04
 * @Description: P&L = 盈亏值 = Profit and Loss 🔶 ROI = 回报率 = Return on Investment 
-->

<template>
    <div class="wave-coat">
        <div class="container">
            <!-- ↓ 添加 z-index 防止弹出元素被下方历史记录遮挡 -->
            <div class="futures"
                style="position: relative; z-index: 1"
            >
                <div class="trading-section"
                    :style="{
                        ...(iPanelHeight ? {maxHeight: `${iPanelHeight + 30}px`} : {}),
                    }"
                >
                    <section class="trading-chart">
                        <header
                            class="header"
                            ref="leftHeader"
                        >
                            <div class="header__main">
                                <div class="header__left">
                                    <WavesCoinMenu
                                        v-model="oVisibleControl.showCoinList"
                                        :offset="[0, 22]" 
                                    ></WavesCoinMenu>
                                    <div class="currency-dropdown">
                                        <!-- ↓ 动态数值容器 --> 
                                        <div class="currency-dropdown__current-currency"
                                            :style="{color: oUpDownStatus.color}" 
                                        >
                                            <img class="big-coin w-[32px]" 
                                                :src="oActiveCoin.icon"
                                            />
                                            <span class="icon">
                                                <IconSvgUse size="32px"  
                                                    :use="oUpDownStatus.icon02" 
                                                />
                                            </span>
                                            <span class="currency">
                                                <span class="balance"
                                                    :style="{
                                                        fontSize: globalStore.innerWidth < 640 ? '20px' : '24px', 
                                                    }"
                                                >
                                                    {{ oActiveCoin['price2show'] }} 
                                                </span>
                                            </span>
                                        </div>
                                        <!-- ↓ 按钮，点击后弹出币种切换菜单 --> 
                                        <div class="dropdown dropdown_lg dropdown_bottomRight balance-wrapper" >
                                            <div class="dropdown__trigger-custom">
                                                <div class="currency-dropdown__trigger cursor-pointer"
                                                    @click="oVisibleControl.showCoinList = !oVisibleControl.showCoinList" 
                                                > 
                                                    <IconSvgUse
                                                        size="14px"
                                                        use="icon-arrow-down" 
                                                        class="opacity-60" 
                                                        :class="{
                                                            'rotate-180': oVisibleControl.showCoinList,
                                                        }"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- ↓ 显示回合终止时间点 ❤️ Waves 币专用 -->
                                    <!-- ↓ 屏幕 <= 1070px 时下落，独立成行显示 -->
                                    <!-- TODO 暂时没有特殊币，未启用 -->
                                    <div class="timer timer--wave"
                                        v-if="oChartStateToolbox.isCorgiWaves"
                                    > 
                                        <div class="timer__title">
                                            {{ $t('waves.RoundEndsIn') }}
                                        </div>
                                        <div class="timer__value">
                                            <div class="timer__time-block">
                                                <span class="timer__time-el">13</span>
                                                <span>:</span>
                                                <span class="timer__time-el">13</span>
                                                <span>:</span>
                                                <span class="timer__time-el">55</span>
                                            </div>
                                            <span class="end-tip"> 
                                                <IconSvgUse use="icon-info" size="18px"/> 
                                                <q-tooltip
                                                    anchor="top middle"
                                                    self="bottom middle"
                                                >
                                                    <p :style="{width: '280px'}" > 
                                                        {{ $t('waves.CorgiWavesTips') }}
                                                    </p>
                                                </q-tooltip>
                                                <!-- ↓ 因为 z-index 级别太低，被遮挡所以使用了 q-tooltip -->
                                                <!-- <Popper :style="oPopperStyle" :hover="true" :arrow="true" placement="top" >
                                                    <IconSvgUse use="icon-info" size="18px"/> 
                                                    <template #content>
                                                        <p :style="{width: '280px'}" > 
                                                            {{ $t('waves.CorgiWavesTips') }}
                                                        </p>
                                                    </template>
                                                </Popper> -->
                                            </span>
                                        </div>
                                    </div>
                                    <!-- ↑ 特殊币专用 -->
                                </div>
                                <!--
                                    Header 首行在此左右分界
                                --> 
                                <div class="header__right">
                                    <div class="ticks-desc"
                                        v-if="oElementVisible.outerTimePick" 
                                    >
                                        <DurationPicker />
                                    </div>
                                    <GameSettingsButtonWavesHowItWorks 
                                        @click="oVisibleControl.bHowItWork = true" 
                                    />
                                    <GameSettingsButtonWavesGear
                                        :showFairnessDialog="()=> oVisibleControl.bFairness = true"
                                    />
                                    <!-- ↓ 公平性图标，动态变化图标和事件 --> 
                                    <template v-if="oElementVisible.outerFairness">
                                        <GameSettingsButtonWavesFairness 
                                            v-if="oChartStateToolbox.isCorgiWaves" 
                                            @click="oVisibleControl.bFairness = true" 
                                        />
                                        <GameSettingsButtonWavesFairnessFormulation
                                            v-else
                                        />
                                    </template>
                                    <GameSettingsButtonWavesROI
                                        @click="oVisibleControl.bCalculator = true"
                                    />
                                </div>
                            </div>
                            <!-- Header 内部上下分界 -->
                            <!-- ↓ 真实币 ❤️ 非 Waves 币专用 -->
                            <div v-if="!oChartStateToolbox.isCorgiWaves" 
                                class="header__bottom header__bottom--fury"
                            >
                                <div class="chart-info">
                                    <div class="chart-info__title">
                                        <span> {{oActiveCoin.name}} </span>
                                        <span> {{oActiveCoin.fullName}} </span>
                                    </div>
                                    <div class="chart-info__value">
                                        <span>
                                            {{ $t('waves.hours24') }}:
                                            {{ oActiveCoin.sWager2show }}
                                        </span>
                                        <span>
                                            H: {{ oActiveCoin.stats24.high.toFixed(oActiveCoin.precision) }}
                                        </span>
                                        <span>
                                            L: {{ oActiveCoin.stats24.low.toFixed(oActiveCoin.precision) }}
                                        </span>
                                    </div>
                                </div>
                                <div class="chart-info">
                                    <div class="chart-info__title">
                                        {{ $t('waves.Funding') }}<!-- 资金费率 --> 
                                    </div>
                                    <div class="chart-info__value">
                                        <span>
                                            {{ Number((chartState_r.fundingRate).toFixed(4)) }}%
                                        </span>
                                        <span>
                                            {{ oCountdown.countDownTime }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </header>
                        <!--
                            ↑ Header
                            | -- 上下分界--- 
                            ↓ 大图表, 
                        --> 
                        <div class="chart-container" >
                            <TheWaveChart
                                :autosize="oChartSetting.autosize"
                                :priceScaleOptions="null"
                                :timeScaleOptions="null"
                                :chartOptions="(oChartSetting.chartOptions as any)"
                                :seriesOptions="(oSeriesOptions as any)" 
                                :rangeChangeHandler="rangeChangeHandler"
                                :data="chartState.data"
                                :markers="chartState.chartMarkers"
                                :selectedPair="chartState.selectedPair"
                                :type="chartState.chartType"
                            ></TheWaveChart> 
                        </div>
                    </section>
                    <!-- ↓ 此处 🎯 在移动端的时候，会显示用户进行中的合约记录 -->   
                    <!-- ↓ v-if：移动端 && 存在进行中的合约 --> 
                    <template v-if="oElementVisible.showTopActiveTable"> 
                        <!-- <p>■■■■■■■■■■■■</p> -->
                        <WavesHistory
                            :mobileActive="true" 
                        ></WavesHistory>
                        <!-- <p>↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑</p>  -->
                    </template>
                    <!-- 
                        ↑ 左侧图表等 
                        ●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●● 
                        ●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●● 
                        ●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●● 
                        ●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●● 
                        ↓ 右侧游戏面板 
                    --> 
                    <section 
                        ref="tradingController"
                        class="trading-controller"
                        :class="{
                            'trading-controller--hide-fee': oChartStateToolbox.isCorgiWaves,
                            'trading-controller--disabled': !userStore.isLoggedIn,
                        }"
                    >
                        <h5 class="trading-controller__title">
                            {{ $t('waves.StartTrading') }}
                        </h5>
                        <WagerSetter
                            v-model="oForm.wager"
                        />
                        <RangeBar 
                            v-model="oForm.multi"
                        />
                        <div class="trading-controller__divider"></div>
                        <!--
                            ↑ 指定杠杆倍数
                            ---------------------------------------- 
                            ↓ 关键单选框
                            ↓ 选择买涨或买跌 
                        -->
                        <div class="take-stop"
                            :style="{
                                '--2810d9dc': oForm.positionType ? '500px' : '20px',
                                '--3f93fb69': oForm.positionType ? '500px' : '0',
                                '--3789d609': oForm.positionType ? '1' : '0',
                                '--288df980': oForm.positionType ? 'scaleY(1)' : 'scaleY(0)', 
                            }"
                        >
                            <div class="take-stop__controls">
                                <label class="checkbox --md" 
                                    :class="{
                                        'checked': checkboxLong,
                                        '--blue': checkboxLong,
                                    }"
                                >
                                    <input type="checkbox" class="input" v-model="checkboxLong" />
                                    <span class="content-wrapper" >
                                        <span>
                                            &nbsp;{{ $t('waves.LongTP') }}
                                        </span>
                                    </span>
                                </label>
                                <label class="checkbox --blue --md"
                                    :class="{
                                        'checked': checkboxShort,
                                        '--blue': checkboxShort,
                                    }"
                                >
                                    <input type="checkbox" class="input" v-model="checkboxShort" />
                                    <span class="content-wrapper">
                                        <span>
                                            &nbsp;{{ $t('waves.ShortTP') }}
                                        </span>
                                    </span>
                                </label>
                            </div>
                            <!-- ↓ 止损设定输入框，默认不可见 -->
                            <div class="take-stop__info-wrap">
                                <!-- ↓组件，在此刻意为 modalData 传入空值 --> 
                                <ProfitLossSetting
                                    ref="profitLossSetting"
                                    :modalData="void 0"
                                ></ProfitLossSetting>
                            </div>
                        </div>
                        <!-- ↑ 止赢止损输入框 -->
                        <!-- ↓ 下方按钮区 -->
                        <div class="btn-block">
                            <div class="btn-block__double" >
                                <ButtonThe3DButton
                                    color="green"
                                    size="lg"
                                    v-click-and-rest
                                    :disabled="oDisabled.up"
                                    :dismark="oDisabled.up"
                                    @click="createPotiion(oLongShort.long)"
                                >
                                    {{ $t('waves.Up') }}
                                </ButtonThe3DButton>
                                <ButtonThe3DButton
                                    color="red"
                                    size="lg"
                                    v-click-and-rest
                                    :style="{margin: 0}" 
                                    :disabled="oDisabled.down"
                                    :dismark="oDisabled.down"
                                    @click="createPotiion(oLongShort.short)" 
                                >
                                    {{ $t('waves.Down') }}
                                </ButtonThe3DButton>
                            </div>
                        </div>
                        <!-- ↓ 分隔线，在小屏幕时显示出来 -->
                        <div class="trading-controller__divider trading-controller__divider--second">
                            <!-- 只是分隔线 -->
                        </div>
                        <!--
                            ↓ 真实币专用选择区 🔶 
                            ↓ 交易费用选项，和一些提示内容 
                        -->
                        <FeeTypeRadio
                            v-if="!oChartStateToolbox.isCorgiWaves"
                        ></FeeTypeRadio>
                    </section>
                    <!-- ↑ 右侧游戏面板 --> 
                </div>
            </div>
            <!-- ↓ 最下方的历史记录 -->
            <section v-if="1" class="wide-controler">
                <CasinoHistoryWavesHistory/> 
            </section>
        </div>
    </div>
    <!--
        ↓弹出窗口，放在最下方 
    -->
    <HowItWorks
        v-model="oVisibleControl.bHowItWork"
    ></HowItWorks>
    <Fairness
        v-model="oVisibleControl.bFairness"
    ></Fairness>
    <!-- ↓ 一定要使用 v-if 以便每次打开窗口重载 -->
    <RoiCalculator
        v-if="oVisibleControl.bCalculator"
        v-model="oVisibleControl.bCalculator" 
    ></RoiCalculator>
</template>


<script lang="ts">
import Popper from "vue3-popper";
import HowItWorks from './_components/howItWorks.vue';
import Fairness from './_components/fairness.vue';
import RoiCalculator from './_components/RoiCalculator.vue';
import DurationPicker from './_components/durationPicker.vue';
import RangeBar from './_components/rangeBar.vue';
import WagerSetter from './_components/wagerSetter.vue';
import TheWaveChart from './_components/TheWaveChart.vue';
import ProfitLossSetting from './_components/profitLossSetting.vue'; 
import WavesCoinMenu from "./_components/wavesCoinMenu.vue";
import WavesHistory from '@/components/Casino/History/wavesHistory.vue'; 
import FeeTypeRadio from './_components/feeTypeRadio.vue'; 
// == ↑ vue 组件 ====================================== 
import useSettingsStore from '@/stores/settings/index';
import useGlobalStore from '@/stores/global';
import { useJoinStateStore } from '@/stores/cansino/joinState';
import { useUserStore } from '@/stores/user'; 
// == ↑ stores 区 ====================================== 
import { HistoryTabsEnum } from '@/components/Casino/History/Tabs/ts/Tabs';
import {toCloseLoading} from '@/layouts/gameCoat/ts/gameCoat';
import { oMethods } from './ts/wavesMethods';
import { oCoinMap } from '@/socket/game/dto/waves.dto';
import futuresBGM from '@/assets/mp3/game_general_bgm.mp3';

import {
    chartState_r, 
    fnGetChartStateToolbox_oi,
    fnGameForm_Ot,
    oWavesBetForm_a,
    settingsState_f, 
    fnSettingCenter_Ft, 
    oPositionData_i, 
    oPositionCenter_yt, 
    oElementVisible, 
} from '@/pages/casino/futuresGame/ts/wavesControlCenter'; 
import {
    oColorInfo,
    chartOptions,
    seriesOptions,
    oPnlFlat,
    aDisCountMap,
    aCoinList,
    oDefaultCoin,
    oPairsMap,
    oLongShort,
    oTimeMS,
    iDefaultMulti,
} from './ts/wavesData'; 
import { useAmountMemoryStore } from "~/stores/cansino/amountMemory";

// ============ ↑ 导入 ================================================= 

export default defineComponent({ 
    name: 'futuresGame',
    components: {
        Popper, 
        Fairness, 
        HowItWorks, 
        RoiCalculator, 
        DurationPicker, 
        RangeBar, 
        WagerSetter, 
        TheWaveChart,
        ProfitLossSetting,
        WavesCoinMenu, 
        WavesHistory, 
        FeeTypeRadio,
    },
    provide: {
        sNowTab: HistoryTabsEnum.active,
    },
    data(){
        return {
            oMusic: import.meta.client && new MusicControler({
                bg: {
                    src: futuresBGM,
                    loop: true,
                    isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
                },
            } as any),
            ...{
                // ↓ 控制界面系列 --------- 
                aCoinList,
                aDisCountMap,
                colorRed: oColorInfo.red.color, 
                colorGreen: oColorInfo.green.color, 
                iPanelHeight: 0, // 右侧操作面板 DOM 高 
            },
            ...{
                // ↓ 表单输入系列 ----------
                checkboxLong: !!0, 
                checkboxShort: !!0, 
            },
            oLongShort, // 合约类型 
            oPnlFlat, // 手续费类型方式 
            oCountdown: this.useCountdown(), // 内部的 oCountdown.countDownTime 用于页面显示 
            oSettingsStore: useSettingsStore(),
            globalStore: useGlobalStore(),
            joinStateStore: useJoinStateStore(), 
            userStore: useUserStore(), 
            oChartSetting: {
                autosize: true, // chartOptions 内也有此属性，默认为 true 
                chartOptions,
            },
            oVisibleControl: { // 元素可见性管理 
                bHowItWork: !!0,
                bFairness: !!0,
                bCalculator: !!0,
                showCoinList: !!0,
            },
            // --- ↓ 管理中心 ----------------------------------------- 
            chartState_r,
            oChartStateToolbox: fnGetChartStateToolbox_oi(),
            oForm: oWavesBetForm_a, // 表单对象
            oFn4Form: fnGameForm_Ot(), // 配套方法包，
            oWavesSettings: settingsState_f,
            oFn4Setting: fnSettingCenter_Ft(),
            oPositionData: oPositionData_i, 
            oPositionCenter: oPositionCenter_yt(), 
            oElementVisible,
            // --- ↑ 管理中心 ----------------------------------------- 
            futuresUpdate_receiver_ready: false, // 值为真才能建仓 
        };
    },
    computed: {
        isMobileMode(){
            if (!this.globalStore.client) {
                return false; // 默认不是移动设备 
            }
            const bResult = this.globalStore.innerWidth < 768; 
            // console.log("bResult", bResult); 
            return bResult; 
        },
        // ↓ 当前币 
        oActiveCoin(){
            const {selectedPair, stats24} = this.chartState_r; 
            const oResult = this.aCoinList.find(cur => { 
                return cur.pairName === selectedPair; 
            });
            const oPairSetting = this.oFn4Setting.currentPairSettings; 
            const precision = oPairSetting?.precision || 2;
            const price2show = number2LocaleString(
                this.oChartStateToolbox.currentPriceByPair,
                precision,
            );
            const sWager2show = (()=>{
                const oUnit = (
                    stats24.wager >= 1_000_000
                    ? { val: 1_000_000, sName: 'M', iTailLong: 1 }
                    : { val: 1_000, sName: 'K', iTailLong: 2 }
                );
                const fResult = stats24.wager / oUnit.val;
                const sResult = fResult.toFixed(oUnit.iTailLong) + oUnit.sName;
                return sResult; 
            })();
            const oFinalCoin = {
                stats24,
                price2show,
                sWager2show,
                precision,
                ...(oResult || oDefaultCoin),
            };
            return oFinalCoin; 
        },
        // ↓ 结算时间点 
        iEndOfFundingPeriod(){
            const oPairSetting = this.oFn4Setting?.currentPairSettings; 
            const ts = oPairSetting?.endOfFundingPeriod; 
            const timeRight = ts > Date.Now(); 
            if (timeRight){
                return oPairSetting.endOfFundingPeriod; 
            }else if (ts){
                const sNextRound = new Date(ts).toLocaleString();
                const sNow = Date.getReal().toLocaleString();
                console.error(`注意时间有误：\n下一轮：${sNextRound} < \n当前时：${sNow}`, );
            }
            const iFaleTime = Date.Now() + oTimeMS.HOUR * 8;
            return iFaleTime; 
        },
        // ↓ 屏幕宽度 
        iClientWidth(){
            if (!this.globalStore.client) {
                return 500;
            }
            return this.globalStore.innerWidth;
        },
        chartState(){
            const oResult = this.oChartStateToolbox?.chartState;
            return oResult;
        },
        // ↓ 涨跌配置项
        oUpDownStatus(){
            const iIndex = this.oChartStateToolbox?.currentPriceStatus || 0; 
            // ↓ 示例：{ color: "#ed1d49", icon: "icon-double-chevron-down", icon02: 'xxx' } 
            const oTarget = oColorInfo[iIndex];
            return oTarget;
        },
        // ↓ 图表配置对象 
        oSeriesOptions(){
            const oPairSetting = this.oFn4Setting.currentPairSettings; 
            const precision = oPairSetting?.precision || 2;
            const minMove = Number((0.1 ** precision).toFixed(precision));
            const priceFormat = {
                ...seriesOptions.priceFormat,
                precision,
                minMove,
            };
            const oResult = {
                ...seriesOptions,
                priceFormat,
                priceLineColor: this.oUpDownStatus.color,
            };
            return oResult;
        },
        // ↓ 红绿按钮禁用状态管理 
        oDisabled(){
            const isReady2Establish = this.oFn4Form.isReady2Establish; 
            const long = this.oForm.positionType === oLongShort.long;
            const short = this.oForm.positionType === oLongShort.short;
            const receiverReady = this.futuresUpdate_receiver_ready;
            const oResult = {
                up: !receiverReady || !isReady2Establish || short, // 值为真则禁用 
                down: !receiverReady || !isReady2Establish || long,
            };
            if (import.meta.client && import.meta.dev && oResult.up && oResult.down){
                console.log("按钮全禁", this.oFn4Form); 
            }
            return oResult;
        },
    },
    // ==== ↑ data, computed, =====================
    watch:{
        checkboxLong(bNewVal){
            this.changeBetMode(oLongShort.long, !!bNewVal);
        },
        checkboxShort(bNewVal){
            this.changeBetMode(oLongShort.short, !!bNewVal);
        },
        iEndOfFundingPeriod(iNewTime){
            console.log("Watch 捕获了“结算时间点” 倒计时更新，目标时间：🧿", new Date(iNewTime).toLocaleString()); 
            this.oCountdown.starter(iNewTime);
        },
    },
    methods: {
        ...oMethods,
    },
    beforeMount(){
        toCloseLoading();
    },
    beforeCreate(){
        // console.log('waves beforeCreate ☢️☢️');
        const route = useRoute(); 
        const sCoin = route.params.id; 
        if (sCoin === 'abc123' && Date.Now() < new Date('2025-03-01').getTime()){
            throw new Error("这是一个用于测试的报错 abc123");
        }
        if (sCoin && Reflect.has(oCoinMap, sCoin as string) == false){ // 参数有误 
            const path = useNuxtApp().$localePath('/404');
            console.log(`错误币种参数：${sCoin} =>`, path); 
            navigateTo({
                path,
                replace: true,
                query: {
                    from: encodeURIComponent(route.fullPath),
                },
            });
        }
    },
    async mounted(){
        this.oPositionCenter.futuresUpdate_receiver();
        setTimeout(()=>{
            // ↓ 值为真方可下注（需要在 futuresUpdate_receiver() 执行后设为 true  
            this.futuresUpdate_receiver_ready = true;
        }, 500);
        // ↓ 监听右侧面板高度变化： 
        this.watchRightPanelResize(); 
        const route = useRoute(); 
        const sCoinOfRoute = route.params.id; 
        const pair = `${sCoinOfRoute}_USDT` as oPairsMap; 
        // ↓ 这是初始化赋值，务必在顶部先执行 
        this.chartState_r.selectedPair = pair; // 关键赋值 
        // ↑ 第 1️⃣ 先把币种记录起来，用于后续工作， 
        // ================================================== 
        // ↓ 第 2️⃣ 步先查询游戏设定，得到巨大对象，也会得到 currentPeriod（rangeMs） 
        await this.oFn4Setting.getSettings(); 
        const rangeMs = this.oFn4Setting.settingsState.currentPeriod; 
        const curPairSettingsAndCurrency = this.oFn4Setting.curPairSettingsAndCurrency; 
        this.oForm.multi = iDefaultMulti; // 先进行倍数值复位 
        const amountMemory = useAmountMemoryStore();
        this.oForm.wager = amountMemory.getLastAmount() || curPairSettingsAndCurrency.defaultWager;
        if (0 && import.meta.dev){
            console.log('☣️ 当前 pair =>', pair); 
            // console.log("时间粒度 =>", rangeMs); 
            // console.log("币种配置信息 =>", curPairSettingsAndCurrency); 
            console.log("当前倍数 =>", this.oForm.multi); 
        }
        this.oChartStateToolbox.setSelectedTick(rangeMs); 
        // ↓ 查询一片数据（返回一片数据的同时，将触发实时数据的推送） 
        await this.oChartStateToolbox.getPairHistory({ 
            pair, 
            rangeMs, 
        }); 
        // ↓ 启动无限递归
        this.oChartStateToolbox.smoothChart(); 
        // ↓ 订阅实时数据 
        if (true){
            this.oChartStateToolbox.subscribeOnAggregatedPrices(); 
            this.oFn4Setting.subscribeOnFuturesSettingsUpdate();
            // this.oPositionCenter.futuresUpdate_receiver(); // 需要上移提前执行 
            this.oPositionCenter.subscribeOnPublicPosition();
        }
        // ↓ 切换币种后状态复位 
        if (this.oForm.positionType){
            this.changeBetMode(this.oForm.positionType, true);
        }
        // ↓ 用于调试 
        if (0 && import.meta.dev){
            this.changeBetMode(oLongShort.long, true);
        }
        this.oCountdown.starter(this.iEndOfFundingPeriod);
    },
    beforeUnmount(){
        console.log('beforeUnmount | waveGame 游戏退场 ->->->->->');
        this.oCountdown.stopper();
        this.oChartStateToolbox.leaveRoom();
        this.oPositionCenter.unsubscribeOnPublicPosition();
        this.oPositionCenter.unSubscribeOnFuturesPositions();
    },
});

</script>


<style scoped lang="scss" src="./style/corgiwavesGame.scss" ></style> 
<style scoped lang="scss" src="./style/corgiwavesGame03.scss" ></style> 
<style scoped lang="scss" src="./style/corgiwavesGameB01.scss" ></style> 

<style scoped lang="scss"> 
.wave-coat{
    padding: 34px 0;
    min-height: 400px;
    .container{
        margin: 0 auto;
        max-width: 1088px;
        padding-left: 24px;
        padding-right: 24px;
        position: relative;
        width: 100%;
    }
}

@media (max-width: 1000px) {
    .wave-coat{
        padding-top: 15px;
    }
}

@media (max-width: 768px) {
    // ↓ 小屏时缩小 padding-x 同原版， 
    .wave-coat .container {
        padding-left: 16px;
        padding-right: 16px;
    }
}

</style>

<style lang="scss">
// 非 scoped 全局属性 
// .waves-game-alert_mark_f5u8o6h5fd9cf{
//     --color: rgb(27, 184, 61);
//     border: solid 2px;
//     border-color: var(--color); 
//     min-width: 300px;
//     max-width: 90vw;
//     background-color: #303A4A;
//     .q-icon{
//         color: var(--color); 
//     }
//     .q-notification__caption{
//         color: #b8c4d6; 
//     }
//     &.red{
//         --color: rgb(237, 29, 73);
//     }
// }

</style>


